export default __webpack_public_path__ + "static/media/hht1_ep11_minisitcom_03.f2c15047.png";